import { render, staticRenderFns } from "./ServiceAttarchComponent.vue?vue&type=template&id=49ccb0f0&scoped=true&"
import script from "./ServiceAttarchComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceAttarchComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAttarchComponent.vue?vue&type=style&index=0&id=49ccb0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ccb0f0",
  null
  
)

export default component.exports